import {safeproMiddleWare} from "axiosApi";
import {useCallback, useState} from "react";
import {handleRequestError} from "utils";
import {useUserAuthContext} from "../context/UserAuthContext";

type UpdateResponse = any;

export const usePricing = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
    const { userDetails: { token, },} = useUserAuthContext();

    const updateProviderCost = useCallback(
    async (providerName: string, amount: string | number, businessId?: string): Promise<UpdateResponse> => {
      setError(null);
      if (String(amount).trim() === "" || Number.isNaN(Number(amount)) || Number(amount) < 0) {
        const msg = "Enter a valid non-negative amount.";
        setError(msg);
        return Promise.reject(new Error(msg));
      }

      setLoading(true);
      try {
        const clientId = process.env.REACT_APP_CLIENT_ID || "";
        const bid = businessId || "";

        return await safeproMiddleWare.post(
            `/user-provider-cost`,
            {providerName, amount: String(amount), businessId: bid},
            {
                headers: {
                    "Content-Type": "application/json",
                    "client-id": clientId,
                    Authorization: `Bearer ${token}`,
                    "x-api-version": "v3"
                },
            }
        );
      } catch (err: any) {
        const handled = handleRequestError(err);
        const message = handled?.message || handled?.error || String(err?.message || "Update failed");
        setError(message);
        return Promise.reject(handled || err);
      } finally {
        setLoading(false);
      }
    },
    [token]
  );

  return { updateProviderCost, loading, error, setError };
};

export default usePricing;